import type { RelationshipOptions } from '../types.js';
import { expressionRules } from '../rules/expression.js';

/**
 * 通过表达式获取配置
 */
export function getOptions(text: string): Partial<RelationshipOptions> {
  for (const item of expressionRules) {
    const match = text.match(item.exp);
    if (match) {
      return item.opt(match);
    }
  }
  return {};
}
